import {
	BUSINESS_UNIT_MFA_TABLE_ID,
	BUSINESS_UNIT_MOBILE_SDK_TABLE_ID
} from 'src/apps/dashboard/constants/Dashboard';

export const HEADER = {
	showBusinessUnitSelector: true,
	showLastUpdated: true
};

export const MOBILE_RESET_TABLE_IDS = [
	BUSINESS_UNIT_MFA_TABLE_ID,
	BUSINESS_UNIT_MOBILE_SDK_TABLE_ID
];
